module.exports = __webpack_public_path__ + "img/google-drive.d7b752ea.png";